import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    /** Amber by default. A screen whose amber is already spent (Painel) passes a quiet one. */
    variant?: ButtonProps['variant'];
  };
  /** For a section of a longer page (Painel): the same anatomy with less air, so two of them don't fill a screen. */
  compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  compact = false,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center animate-fade-in',
        compact ? 'py-8' : 'py-16',
      )}
    >
      <div className={cn('rounded-2xl bg-muted mb-4', compact ? 'p-3' : 'p-4')}>
        <Icon className={cn('text-muted-foreground', compact ? 'h-6 w-6' : 'h-8 w-8')} />
      </div>
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className={cn('text-sm text-muted-foreground max-w-sm', compact ? 'mb-5' : 'mb-6')}>{description}</p>
      {action && (
        <Button variant={action.variant} onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
};
